import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { useLocation } from '@gatsbyjs/reach-router';
import { SelectorContent, useSelectorMachineContext } from '@printdeal/product-selector';
import { transformUrl } from 'unpic';
import { addProductStructuredData } from '../../../helpers/StructuredData/Product';
import { IProductPage } from '../../../types/product/productDetailPage';

interface Props {
  productPage: IProductPage,
  selector: SelectorContent,
}

const ProductJsonLd = ({
  productPage,
  selector,
}: Props) => {
  const { portalConfiguration } = useStaticQuery(
    graphql`
      {
        portalConfiguration {
          channel {
            name
          }
        }
      }
  `,
  );
  const {
    productName, description, featuredImage,
  } = productPage;

  const location = useLocation();
  const totalPrice = useSelectorMachineContext((state) => state.context.totalPrice);

  // get the price from cents
  const getEurPrice = (cents: number | null = null) => (cents
    ? (cents / 100).toString() : undefined);

  const featuredImageUrl = featuredImage?.url ? transformUrl({
    url: featuredImage.url,
    width: 120,
  }) : undefined;

  const jsonLD = addProductStructuredData({
    name: productName,
    sku: selector.product.key,
    image: featuredImageUrl?.toString(),
    description: description?.childMarkdownRemark?.excerpt,
    category: productPage?.productCategory?.categoryName,
    url: location?.href,
    brandName: portalConfiguration.channel.name,
    price: getEurPrice(totalPrice?.totalGross?.centAmount),
    productReviews: productPage.reviews,
  });

  // Google Merchant Center needs to crawl product urls to check if the website matches with the productfeed
  return (
    <script type="application/ld+json">
      {JSON.stringify(jsonLD)}
    </script>
  );
};

export default ProductJsonLd;
